module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAYAAABytg0kAAAAFUlEQVR42mJkYGCYCcQMTAxQABBgAAiUAJ2xa5shAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/transparent-white.png
// module id = 1098
// module chunks = 2